














import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue, { VueConstructor } from 'vue'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import { BModal, BvModalEvent } from 'bootstrap-vue'
import { StringMap } from '@/shared/utils/map'
import { DialogInstance } from '@/shared/dialog/dialog-instance'
import { DialogResultImpl } from '@/shared/dialog/dialog-result'

@Component({
  name: 'respondeco-dialog-container',
  components: {
    BModal,
  },
})
export default class RespondecoDialogContainer extends Vue implements Hooks {
  public dialogs: Array<DialogInstance<any>> = []

  private dialogService = Injector.get(DialogService)

  public data() {
    return {
      component: undefined,
    }
  }

  public mounted() {
    this.$root.$on('bv::modal::hidden', (event: BvModalEvent, id: string) => {
      this.remove(id)
    })

    this.dialogService.register({
      open: (component: VueConstructor, props?: StringMap<any>) => {
        return new DialogResultImpl((submit, dismiss) => {
          const dialogInstance = new DialogInstance({
            component,
            events: {
              close: () => {
                this.$bvModal.hide(dialogInstance.ref.id)
              },

              dismiss: () => {
                dismiss()
              },

              submit: (result: any) => {
                submit(result)
              },
            },
            props,
          })

          this.dialogs.push(dialogInstance)

          this.$nextTick(() => {
            this.$bvModal.show(dialogInstance.ref.id)
          })
        })
      },
    })
  }

  public remove(id: string): void {
    this.dialogs = this.dialogs.filter(dialog => dialog.ref.id !== id)
  }
}
